export const searchForErrors = (errors: Object, setState: Function) => {
    if(errors !== {}){
        setState(true)
    } else {
        setState(false)
    }
}